const styles = {
  wrapper: 'bg-black-light z-10',
};

export default styles;
